import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  dialogPaper: {
    borderRadius: theme.shape.borderRadius,
    minHeight: '30dvh',
    maxHeight: '80dvh'
  },
  header: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between'
  },
  dialogContent: {
    minWidth: 500,
    maxWidth: 600,
    padding: theme.spacing(2, 0)
  },
  conversationTitle: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  selectedConversation: {
    backgroundColor: theme.palette.action.selected
  },
  searchInputContainer: {
    alignItems: 'center',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    boxShadow: 'none',
    display: 'flex',
    margin: theme.spacing(3, 0, 2, 0),
    padding: theme.spacing(0.75, 2),
    width: '100%'
  },
  searchInput: {
    marginLeft: theme.spacing(1),
    flex: 1,
    fontSize: '0.95rem'
  },
  clearButton: {
    padding: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5)
  },
  statusRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  resultItem: {
    borderRadius: theme.shape.borderRadius,
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  }
}));
